import React from 'react';

export const CameraPlaceholder: React.FC = () => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-[90%] h-[90%] bg-gradient-to-br from-green-500/30 to-fuchsia-500/30 rounded-lg border-2 border-dashed border-white/30 flex items-center justify-center">
        <span className="text-white/50 text-sm">Caméra</span>
      </div>
    </div>
  );
};
